<template>
    <div  v-if="!isButtonDisable">
        <button class="font-medium bg-primary-color text-secondary-color text-20 rounded-full w-full py-2.5"
                @click="clickRedeem()">
            <span v-html="buttonLbl"></span>
        </button>
    </div>
    <div class="w-full" v-else>
        <button class=" font-medium bg-im-gray-767676 text-white text-20 rounded-full w-full py-2.5">
            <span v-html="buttonLbl"></span>
        </button>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import { CampaignType } from "@/helper/StaticValue.js";
import { useLocale } from "@/feature/LocaleFeature" 
import { inject } from 'vue';

export default {
    setup: function() {
        const { lbl } = useLocale()
        const modal = inject("Modal")

        return {
            lbl,
            modal,
        }
    },
    name: "RedeemButton",
    props: {
        detailController: Object,
        landingFlow : Object,
    },
    data: function() {
        return {
            type: null,
            point: 0,
            pointType: '',
            quantity: 0,
            campaign: {},

            buttonClass: 'disable',
            buttonLbl: '',
            buttonInitiated: false,
            isAllowRedeem: false,
            isUseDefault: false
        };
    },
    created: function () {
        this.type = this.detailController.type;
        this.point = this.detailController.point;
        this.pointType = this.detailController.pointType;
        this.quantity = this.detailController.quantity;
        this.campaign = this.detailController.campaign;

        this.buttonLbl = this.lbl.iimmpact.redeem_button.default;
        this.isAllowRedeem = this.campaign.isConditionPass;
        this.isButtonDisable = !this.campaign.isConditionPass;
    },
    mounted: function () {
        this.initialRedeemButton();
        this.buttonClass = this.getRedeemButtonClass();
        this.buttonLbl = this.cleanRedeemButtonLabel();
    },
    methods: {
        //Event
        clickRedeem: function () {
            if (this.isAllowRedeem) {
                if (this.landingFlow.states.isLogin) {
                    this.$emit('clickRedeem');
                } else {
                    this.modal.alertModal
                        .clearModal()
                        .setTitle(this.lbl.iimmpact.redeem_button.alert_headline)
                        .setMsg(this.lbl.iimmpact.redeem_button.alert_login_msg)
                        .setBtnOk(this.lbl.iimmpact.redeem_button.alert_ok_btn)
                        .setTag('redeem-btn')
                        .show();

                    this.modal.alertModal
                        .onClickOk(() => {
                            this.$router.push('/register');
                        });
                }
            }
        },
        //Function
        initialRedeemButton: function () {
            //Check is campaign supported.
            if (this.type == CampaignType.Bid ||
                this.type == CampaignType.Event ||
                this.type == CampaignType.Media) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notsupport';
                this.buttonLbl = this.lbl.iimmpact.redeem_button.notSupport;
            }

            //check published.
            if (this.campaign.statusID != 3) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notpublish';
                this.buttonLbl = this.lbl.iimmpact.redeem_button.notPublish;
            }

            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'expired';
                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.iimmpact.redeem_button.campaignExpiredBuy : this.lbl.iimmpact.redeem_button.campaignExpired;
            }
            //Check sold out.
            if (this.quantity <= 0) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "soldout";
                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.iimmpact.redeem_button.soldOutBuy : this.lbl.iimmpact.redeem_button.soldOut;
            }
            //Do validate when logged in.
            if (this.landingFlow.states.isLogin) {
                //Check user enough point.
                if (this.point > this.landingFlow.getters.getUserPoint()) {
                    if (this.pointType && this.pointType != 'use') {
                        //Get point, do nothing.
                    } else {
                        this.isAllowRedeem = false;
                        this.isButtonDisable = true;
                        this.buttonClass = 'notenoughpoint';
                        this.buttonLbl = this.lbl.iimmpact.redeem_button.notEnoughPoint;
                    }
                }
                //Handle common case for custom text.
                if (!this.campaign.isConditionPass) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    //Use api text message.
                    if (this.isUseDefault) {
                        this.buttonClass = 'condition';
                        this.buttonLbl = this.campaign.conditionAlert;
                    } else {
                        switch (this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.buttonLbl = this.lbl.iimmpactnone;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.buttonClass = "soldout";
                                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.iimmpact.redeem_button.soldOutBuy : this.lbl.iimmpact.redeem_button.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.buttonClass = "maxperson";
                                this.buttonLbl = this.lbl.iimmpact.redeem_button.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.buttonClass = "cooldown";
                                this.buttonLbl = this.lbl.iimmpact.redeem_button.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.buttonLbl = this.lbl.iimmpact.redeem_button.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.buttonClass = "eligible";
                                this.buttonLbl = this.lbl.iimmpact.redeem_button.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.buttonClass = "expired";
                                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.iimmpact.redeem_button.campaignExpiredBuy : this.lbl.iimmpact.redeem_button.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.iimmpact.redeem_button.campaignNotAvailableBuy : this.lbl.iimmpact.redeem_button.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.buttonClass = "condition";
                                this.buttonLbl = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    this.buttonClass = 'allow';

                    if (this.campaign.customCaption) {
                        this.buttonLbl = this.campaign.customCaption;
                    }
                }
            } else {
                this.buttonClass = 'allow';

                if (this.campaign.customCaption) {
                    this.buttonLbl = this.campaign.customCaption;
                }
            }
            this.$nextTick(() => {
                this.buttonInitiated = true;
            });
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.buttonLbl);
        },
        getRedeemButtonClass: function () {
            if (!this.isAllowRedeem)
                return this.buttonClass;

            return 'allow';
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
